import { RouteObject } from 'react-router-dom';

import { PATH } from '~/constants/route-path';
import TermsConditions from '~/pages/TermsConditions/TermsConditions';
import GuestRoute from '~/routes/GuestRoute';

const TERMS_CONDITIONS_ROUTES: RouteObject[] = [
  {
    path: PATH.TOS,
    element: (
      <GuestRoute>
        <TermsConditions />
      </GuestRoute>
    ),
  },
];

export { TERMS_CONDITIONS_ROUTES };
